import { render, staticRenderFns } from "./modal-social-member-request.vue?vue&type=template&id=e4316640&scoped=true&lang=pug"
import script from "./modal-social-member-request.js?vue&type=script&lang=js&external"
export * from "./modal-social-member-request.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-member-request.vue?vue&type=style&index=0&id=e4316640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4316640",
  null
  
)

export default component.exports